<template>
    <mu-sub-header style="transform:scale(1.2)">列表标题</mu-sub-header>
</template>
<script>
export default {
    name: 'badge'
}
</script>



// WEBPACK FOOTER //
// subHeader.vue?3b010325